import { render, staticRenderFns } from "./ProjetosInstitucional.vue?vue&type=template&id=296d0dff&"
import script from "./ProjetosInstitucional.vue?vue&type=script&lang=js&"
export * from "./ProjetosInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports